<div class="fund-actions">
  @for (action of actions(); track action.type) {
    <app-action-card
      [icon]="action.icon || ''"
      [iconName]="action.iconName"
      [iconColor]="action.iconColor || 'white'"
      [iconSize]="action.iconSize || 16"
      [iconType]="action.iconType || 'svg'"
      [title]="action.titleKey | translateLang"
      [subtitle]="action.subtitleKey | translateLang"
      (clicked)="onActionClick(action.type)"
    ></app-action-card>
  }
</div>
